import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page } from "react-pdf";
import { FaFileAlt } from "react-icons/fa";
// import pdf from "../../Assets/../Assets/Soumyajit_Behera-BIT_MESRA.pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const handleDownload = () => {
    // Replace 'pdf-file.pdf' with the actual filename of your PDF file
    const pdfUrl = 'https://drive.google.com/file/d/1zrsWgc2tg8WX_fx_JTQS-qkzcNTqtpBM/view?usp=drive_link';
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'https://drive.google.com/file/d/1zrsWgc2tg8WX_fx_JTQS-qkzcNTqtpBM/view?usp=drive_link'; // Specify the name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div >
      <Container fluid className="resume-section ">
          <Particle />
          <Row style={{ justifyContent: "center", position: "relative" }}>
            <Button
              variant="primary"
              onClick={handleDownload}
              target="_blank"
              style={{ maxWidth: "250px" }}
            >
              <FaFileAlt />
              &nbsp;Visit CV
            </Button>
          </Row>
          <div className="h-screen mt-5 w-min-screen bg-cover bg-position-center">
            <h1 className="resume-heading">
              <strong className="purple">My </strong>Resume
            </h1>
            <p style={{ color: "white" }}>
              Here is my{" "}
              {/* <a href="https://drive.google.com/file/d/1zrsWgc2tg8WX_fx_JTQS-qkzcNTqtpBM/view?usp=drive_link" target="_blank" rel="noopener noreferrer"> */}
                CV {" "}
              {/* </a>{" "} */}
              for your review.
            </p>
          </div>
          <Row className="resume">
            <Document className="d-flex justify-content-center">
              <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
          </Row>

          <Row className="mb-5 mt-5 p-5" style={{ justifyContent: "center", position: "relative" }}>
            <Button
              variant="primary"
              // href={pdf}
              onClick={handleDownload}
              target="_blank"
              style={{ maxWidth: "250px" }}
            >
              <AiOutlineDownload />
              &nbsp;Download CV
            </Button>
          </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;